import {Component, EventEmitter, Input, Output} from "@angular/core";

@Component({
    selector: "fhm-search-grid",
    templateUrl: "./search-grid.component.html",
    styleUrls: ["./search-grid.component.scss"],
    standalone: false
})
export class SearchGridComponent {

    sortedColumn: string;
    sortedColumnAscend: boolean;

    @Input() records: any[];

    @Input() columns: string[];

    @Input() sortableColumns: string[];

    /**
     * Indicates if the first column is clickable link
     */
    @Input() showLink: boolean;

    @Input() showDelete: boolean;

    @Input() showDeleteFunc: (record: any) => boolean;

    @Input() showRecontinueFunc: (record: any) => boolean;

    @Input() showDownloadLog: boolean;

    @Input() showDownloadReport: boolean;

    @Input() showAction: boolean;

    @Input() actionLabel: string;

    @Input() type: string;

    @Input() styleColumnFn: (columnName: string, record: any) => any;

    @Input() valueColumnFn: (columnName: string, record: any) => any;

    /**
     * Emits a selected record
     * @type {EventEmitter<any>}
     */
    @Output() selectRecord: EventEmitter<any> = new EventEmitter<any>();

    @Output() deleteRecord: EventEmitter<any> = new EventEmitter<any>();

    @Output() recontinueRecord: EventEmitter<any> = new EventEmitter<any>();

    @Output() downloadLog: EventEmitter<any> = new EventEmitter<any>();

    @Output() downloadReport: EventEmitter<any> = new EventEmitter<any>();

    @Output() actionClicked: EventEmitter<any> = new EventEmitter<any>();

    @Output() columnSorted: EventEmitter<{column: string, ascend: boolean}> = new EventEmitter<{column: string; ascend: boolean}>();

    @Output() linkColumnClicked: EventEmitter<any> = new EventEmitter<any>();

    isColumnSorted(column: string): boolean {
        return this.sortableColumns && this.sortableColumns.indexOf(column) >= 0;
    }

    sortColumn(column: string): void {
        if (column === this.sortedColumn) {
            if (!this.sortedColumnAscend) {
                this.sortedColumn = undefined;
            } else {
                this.sortedColumnAscend = !this.sortedColumnAscend;
            }
        } else {
            this.sortedColumn = column;
            this.sortedColumnAscend = true;
        }
        this.columnSorted.emit({column: this.sortedColumn, ascend: this.sortedColumnAscend});
    }
}
